import { render } from "./open_record.vue?vue&type=template&id=5a0ae2e8&scoped=true"
import script from "./open_record.vue?vue&type=script&lang=js"
export * from "./open_record.vue?vue&type=script&lang=js"

import "./open_record.vue?vue&type=style&index=0&id=5a0ae2e8&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0ae2e8"]])

export default __exports__